// extracted by mini-css-extract-plugin
export default {"container":"OrganizationSettings_container__AB37v","header":"OrganizationSettings_header__w3uxU"};